module.exports = __webpack_public_path__ + "static/media/logoForPlaid.3c1b0ec5.png";